var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIconNoCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 225 c-23 -13 -49 -36 -58 -50 -20 -31 -11 -53 41 -92 30 -23 47 -28 93 -28 46 0 63 5 93 28 52 40 62 61 41 92 -23 36 -94 75 -135 75 -19 0 -53 -11 -75 -25z m123 -27 c29 -27 29 -65 1 -95 -27 -29 -65 -29 -95 -1 -29 27 -29 65 -1 95 27 29 65 29 95 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 166 c-10 -26 4 -48 28 -44 17 2 23 10 23 28 0 18 -6 26 -23 28 -13 2 -25 -3 -28 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconNoCross);
export default __webpack_public_path__ + "static/media/EyeIconNoCross.4ab3ba726fb73da05bcaf6db6137c8e1.svg";
export { ForwardRef as ReactComponent };